import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';


@Component({
  selector: 'app-shared-notes-dialog',
  standalone: true,
  imports: [
    DialogModule,
    ButtonModule,
    CommonModule
  ],
  templateUrl: './shared-notes-dialog.component.html',
  styleUrl: './shared-notes-dialog.component.scss'
})
export default class SharedNotesDialogComponent {
  // formValues: any = null;
  @Input() notes: string = '';
  title = 'Notes';
  @Input() visible: boolean = false;
  @Output() closeDialog = new EventEmitter<void>();


  close() {
    this.closeDialog.emit();
    this.visible = false;
  }

}
